/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import { StylingContextState } from 'context/Styling';

export const qrCodeAndVerificationStyles = ({ colors }: StylingContextState) => ({
  stepContent: css`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  `,
  qrCodeContainer: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    background-color: ${colors.white};
    border-radius: 8px;
  `,
  manualEntryText: css`
    margin: 0.5rem 0 0.25rem 0 !important;
  `,
  qrCodeImage: css`
    max-width: 256px;
    width: 100%;
    height: auto;
    border-radius: 4px;
    padding: 0.5rem;
    background-color: ${colors.white};

    @media (max-width: 550px) {
      max-width: 200px;
      padding: 0.5rem;
    }
  `,
  secretContainer: css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 2.5rem;
    background-color: ${colors.background.canvas};
    border-radius: 4px;
    width: 100%;
    max-width: 400px;

    @media (max-width: 550px) {
      flex-direction: column;
      align-items: center;
      padding: 0.5rem;
      gap: 0.5rem;
    }
  `,
  secretText: css`
    width: 100%;
    font-family: 'Courier New', Courier, monospace !important;
    word-break: break-all;
    text-align: center;
    margin: 0 !important;
  `,
  copyButton: css`
    position: absolute;
    right: 0.5rem;
    top: 50%;
    transform: translateY(-50%);
    padding: 0.25rem !important;
    background: transparent !important;
    border: none !important;
    color: ${colors.text.secondary} !important;
    transition: color 0.2s;
    min-width: auto !important;
    width: auto !important;
    outline: none !important;
    box-shadow: none !important;

    &:hover {
      color: ${colors.text.primary} !important;
      background: transparent !important;
    }

    &:focus,
    &:active {
      outline: none !important;
      box-shadow: none !important;
      background: transparent !important;
      border: none !important;
    }

    &.copied {
      color: ${colors.success.main} !important;
    }

    svg {
      width: 18px;
      height: 18px;
    }

    @media (max-width: 550px) {
      position: static;
      transform: none;
    }
  `,
  title: css`
    margin: 0 0 0.25rem 0 !important;
    font-size: 2.5rem !important;
    font-weight: 700 !important;
  `,
  instructions: css`
    text-align: center;
    color: ${colors.text.secondary};
    margin: 0 0 0 0 !important;
  `,
  form: css`
    margin-top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  `,
  codeInputContainer: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0;
    margin: 0;
    width: 100%;

    > div:first-of-type {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      max-width: 400px;
      margin-bottom: 1rem;

      label {
        text-align: center;
        width: 100%;
      }

      .container {
        padding-left: 2.4rem;
        padding-right: 2.4rem;
      }

      input {
        text-align: center;
      }
    }

    > button {
      max-width: 400px;
      width: 100%;
      margin-top: 0.5rem !important;
      margin-bottom: 0 !important;
    }

    > div:not(:first-of-type) {
      margin: 0.5rem 0 !important;
      width: 100%;
      max-width: 400px;
    }
  `,
  divider: css`
    width: 100%;
    height: 1px;
    background-color: ${colors.border.weak};
    margin: 2rem 0 0 0;
  `,
  actionsContainer: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 1rem;
  `,
});
